import React from "react";

export const PrivacyPolicy = () => {
  return (
    <h1 className="text-green m-t-100 p-t-100 p-b-100">Our Privacy Policy page will be coming soon!</h1>
  );
}

export default PrivacyPolicy;